import { ContentNavItem, NavItem } from './NavItem';
import NavOptions from './NavOptions';

const siteAbsoluteUrl = 'https://lucamorrow.com';

const viewParamKey = 'view';

class NavUtil {

  /**
   * https://xxx/#aaa/bbb/ccc and https://xxx/?view=aaa/bbb/ccc  translates to:
   *
   * {
   *   primaryItem: 'aaa',
   *   secondaryItems: ['bbb', 'ccc']
   * }
   *
   * https://xxx/#aaa and https://xxx/?view=aaa translates to:
   *
   * {
   *   primaryItem: 'aaa',
   *   secondaryItems: []
   * }
   *
   * https://xxx and https://xxx/?view= translates to:
   *
   * {
   *   primaryItem: undefined,
   *   secondaryItems: []
   * }
   */
  getNavOptions = (): NavOptions => {
    const navOptions: NavOptions = {
      primaryItem: undefined,
      secondaryItems: [],
    };
    let viewValue = this.getParameterByName(viewParamKey);
    if (!viewValue) {
      viewValue = decodeURIComponent(window.location.hash);
    }
    if (viewValue) {
      const hashParts = viewValue.split('/');
      if (hashParts.length) {
        navOptions.primaryItem = hashParts[0];
        for (let index = 1; index < hashParts.length; index++) {
          navOptions.secondaryItems.push(hashParts[index]);
        }
      }
    } else {
      navOptions.primaryItem = undefined;
    }
    return navOptions;
  }

  navItemAsContentNavItem = (navItem: NavItem): undefined | ContentNavItem => {
    if (navItem.hasOwnProperty('renderMainView')) {
      return navItem as ContentNavItem;
    } else {
      return undefined;
    }
  }

  setHash = (navOptions: NavOptions): void => {
    const optionsUrlSegment = this.buildOptionsUrlSegment(navOptions);
    const hash = `#${optionsUrlSegment}`;
    window.location.hash = hash;
  }

  possiblyRedirectToHashUrl = (): boolean => {
    let viewValue = this.getParameterByName(viewParamKey);
    if (viewValue) {
      const navOptions = this.getNavOptions();
      const redirectUrl = this.navOptionsToHashUrl(navOptions);
      window.location.replace(redirectUrl);
      return true;
    }
    return false;
  }

  navOptionsToQueryUrl = (navOptions: NavOptions): string => {
    const optionsSegment = this.buildOptionsUrlSegment(navOptions);
    const query = optionsSegment ? `?${viewParamKey}=${optionsSegment}` : '';
    const proptocolAndHost = this.getProtocolAndHost();
    const path = window.location.pathname === '/' ? '' : window.location.pathname;
    return `${proptocolAndHost}${path}${query}`;
  }

  navOptionsToHashUrl = (navOptions: NavOptions): string => {
    const optionsSegment = this.buildOptionsUrlSegment(navOptions);
    const hash = optionsSegment ? `#${optionsSegment}` : '';
    const proptocolAndHost = this.getProtocolAndHost();
    const path = window.location.pathname === '/' ? '' : window.location.pathname;
    return `${proptocolAndHost}${path}${hash}`;
  }

  getProtocolAndHost = () => {
    const location = window.location;
    const proptocolAndHost = location.host.indexOf('localhost') === 0 ? `http://${location.host}` : siteAbsoluteUrl;
    return proptocolAndHost;
  }

  buildOptionsUrlSegment = (navOptions: NavOptions): string => {
    let segment = '';
    let nextSeparator = '';
    if (navOptions.primaryItem) {
      segment += `${nextSeparator}${navOptions.primaryItem}`;
      nextSeparator = '/';
    }
    for (const secondaryItem of navOptions.secondaryItems) {
      segment += `${nextSeparator}${secondaryItem}`;
      nextSeparator = '/';
    }
    return segment;
  }

  getParameterByName = (name: string, url = window.location.href) => {
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  buildUrl = (primaryNavItem: NavItem, secondaryNavItems: string[]): string => {
    let url = this.getProtocolAndHost();
    url += '#';
    url += primaryNavItem.key;
    for (const secondaryNavItem of secondaryNavItems) {
      url += '/';
      url += secondaryNavItem;
    }
    return url;
  }

}

const navUtil = new NavUtil();
export default navUtil;
